import { z } from "zod";

export const templateSchema = z.object({
	name: z.string().trim().min(1, "Informe o nome do template"),
	description: z.string().optional(),
});

export type TemplateFormValues = z.infer<typeof templateSchema>;
